import { isAxiosError, AxiosError } from "axios";
import { singleton } from "tsyringe";

// interface & type
import type { ConfirmAxiosError } from "@/shared/libs/http/axios/interface";

@singleton()
export default class ConfirmLibsError implements ConfirmAxiosError {
    isAxiosError = <T>(error: unknown): error is AxiosError<T> => {
        return isAxiosError<T>(error);
    };
}
